import { render, staticRenderFns } from "./CreateNewLanguage.vue?vue&type=template&id=5194e460&"
import script from "./CreateNewLanguage.vue?vue&type=script&lang=js&"
export * from "./CreateNewLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports